import { Alert, Stack, Typography } from "@mui/material";

import { ShipmentTrackingLinkDisplay } from "components/ShipmentTrackingLink";

interface SupplierShipmentTrackingSectionShipment {
  info: Pick<SupplierShipmentInfo, "booked_at" | "type">;
  shipment_status: ShipmentStatusValue;
  tracking_link_info: ShipmentTrackingLinkInfo;
}

interface Props {
  dividerComponent: JSX.Element;
  shipment: SupplierShipmentTrackingSectionShipment;
}

export function SupplierShipmentTrackingSection(props: Props) {
  const { dividerComponent, shipment } = props;

  if (
    shipment?.info?.booked_at == null ||
    shipment.info.type === "MULTI_SHIPMENT_PROJECT" ||
    shipment.shipment_status === "BOOKING_CANCELLED" ||
    shipment.shipment_status === "DELIVERED"
  ) {
    return null;
  }

  if (shipment.tracking_link_info.tracking_link !== null) {
    return (
      <>
        {dividerComponent}
        <ShipmentTrackingLinkDisplay
          trackingLink={shipment.tracking_link_info.tracking_link}
          showWarningOnCopy
        />
      </>
    );
  }
  if (!shipment.tracking_link_info.link_expected) {
    return (
      <>
        {dividerComponent}
        <Stack mb="2rem" direction="column" spacing={1}>
          <Typography mt="1rem" variant="h6">
            No tracking link provided yet.
          </Typography>
        </Stack>
      </>
    );
  }
  return (
    <>
      {dividerComponent}
      <Stack mb="2rem" direction="column" spacing={1}>
        <Typography mt="1rem" variant="h6">
          No tracking link created yet.
        </Typography>
        {shipment.tracking_link_info.link_expected &&
          shipment.tracking_link_info.link_due && (
            <Alert severity="warning">
              The tracking link is due. Carrier has been sent a reminder.
            </Alert>
          )}
      </Stack>
    </>
  );
}
